import React, { createContext, useEffect, useState } from "react";
//import useWeb3 from 'react-use-web3';
import Web3 from "web3";

import {
  CONTRACT_ABI,
  NODE_MGR_ABI,
  CONTRACT_ADDRESS,
  NODE_MANAGER_ADDRESS,
  CHAIN_ID,
  TEST_NET_URL,
} from "../utils/constants";
import { toast } from "react-toastify";

export const RewardManagementContext = createContext();
const { ethereum } = window;
const provider = Web3.providers.HttpProvider(TEST_NET_URL);
//const provider = new Web3.providers.WebsocketProvider('wss://ropsten.infura.io/v3/1234543');
//const web3 = new Web3(new Web3.providers.HttpProvider('https://data-seed-prebsc-1-s1.binance.org:8545')); //new Web3(Web3.givenProvider || provider);
const web3 = new Web3(window.ethereum); //new Web3(Web3.givenProvider || provider);
const contract = new web3.eth.Contract(CONTRACT_ABI, CONTRACT_ADDRESS);
const nodeManager = new web3.eth.Contract(NODE_MGR_ABI, NODE_MANAGER_ADDRESS);

const getNodeManager = async () => {
  console.log({
    nodeManager,
  });
  return nodeManager;
};
const getEthereumContract = async () => {
  // console.log({
  //   web3,
  //   provider,
  //   contract,
  // });

  return contract;
};

export const RewardManagementProvider = ({ children }) => {
  const [currentAccount, setCurrentAccount] = useState("");
  const [totalNodes, settotalNodes] = useState(0);
  const [totalHouse, settotalHouse] = useState(0);
  const [totalBuilding, settotalBuilding] = useState(0);
  const [totalAppartment, settotalAppartment] = useState(0);

  const [myTotalNodes, setmyTotalNodes] = useState(0);
  const [myTotalRewards, setMyTotalRewards] = useState("0.00000000");
  const [myTotalFees, setMyTotalFees] = useState("0.00000000");
  const [currFee, setcurrFee] = useState();

  const [rewardsPerNode, setrewardsPerNode] = useState("0.00000000");
  const [allModule, setallModule] = useState([]);
  //var [updateUsers,setUpdateusers] =useState({updateUsers:[]});
  //const [allModule, setallModule] = useState({allModule:[]});
  const separator = "#";
  const promise = [];
  const nodes = [];

  const [isLoading, setIsLoading] = useState(false);

  const getBalance = async () => {
    const transactionsContract = await getEthereumContract();
    const balance = await transactionsContract.methods
      .balanceOf(currentAccount)
      .call();
    return balance;
  };

  const getTotalAllNode = async () => {
    const transactionsContract = await getEthereumContract();

    const nodeManagerContract = await getNodeManager();

    const accounts = await ethereum.request({ method: "eth_requestAccounts" });
    const account = accounts[0];

    await nodeManagerContract.methods
      .getAllNodes(account)
      .call()
      .then((tNodes) => {
        console.log("tNodes", tNodes);
      });

    await transactionsContract.methods
      .getTotalCreatedNodes()
      .call()
      .then((totalNodes) => {
        console.log("totalNodes", totalNodes);
        settotalNodes(totalNodes);
      });

    for (var i = 0; i < 4; i++) {
      //promise.push(getTotalCreatedNodesByTier(i));
      await transactionsContract.methods
        .getTotalCreatedNodesByTier(i)
        .call()
        .then((totalT1Nodes) => {
          console.log(`totalT${i}Nodes`, totalT1Nodes);
        });
    }
  };

  const getTotalRewardAmount = async (account) => {
    console.log(`currentAccount: ${account}`);
    const transactionsContract = await getEthereumContract();

    const rewardAmountResult = await transactionsContract.methods
      .getRewardAmount()
      .call({
        from: account,
      });

    const rewardAmount = rewardAmountResult.toString().split(",");

    console.log(
      `totalRewards: ${Number(web3.utils.fromWei(rewardAmount[0])).toFixed(18)}`
    );
    console.log(
      `totalTax: ${Number(web3.utils.fromWei(rewardAmount[1])).toFixed(18)}`
    );

    setMyTotalRewards(Number(web3.utils.fromWei(rewardAmount[0])).toFixed(18));
    setMyTotalFees(Number(web3.utils.fromWei(rewardAmount[1])).toFixed(18));

    //web3.utils.fromWei(totalRewards, 'ether')
  };

  const getRewardPerNode = async (account) => {
    const transactionsContract = await getEthereumContract();

    const rewardsPerNode = await transactionsContract.methods
      .getRewardPerNode()
      .call({
        from: account,
      });
    console.log(`rewardsPerNode: ${rewardsPerNode}`);

    setrewardsPerNode(rewardsPerNode);
  };

  const getNodeFee = async (blocktime, reawardamount) => {
    const transactionsContract = await getEthereumContract();

    // const rewardsPerNode = await transactionsContract.methods
    //   .getRewardPerNode()
    //   .call({
    //     from: account,
    //   });
    // console.log(`rewardsPerNode: ${rewardsPerNode}`);

    //setrewardsPerNode(rewardsPerNode);
    const accounts = await ethereum.request({ method: "eth_requestAccounts" });
    const account = accounts[0];
    const nodeManagerContract = await getNodeManager();
    const fee = await nodeManagerContract.methods
      .getNodeFee(account, blocktime, reawardamount)
      .call();
    return fee;
    // .then((f) => {
    //   setcurrFee(f);

    // });
    //
    console.log("result fee", fee);
  };

  const getDateStringServ = (timestamp) => {
    const plus0 = (num) => `0${num.toString()}`.slice(-2);

    const d = new Date(timestamp);

    const year = d.getFullYear();
    const monthTmp = d.getMonth() + 1;
    const month = plus0(monthTmp);
    const date = plus0(d.getDate());
    const hour = plus0(d.getHours());
    const minute = plus0(d.getMinutes());
    const second = plus0(d.getSeconds());
    const rest = timestamp.toString().slice(-5);

    return `${year}-${month}-${date}_${hour}:${minute}:${second}.${rest}`;
  };

  const getTotalNodesByTire = async () => {

    const transactionsContract = await getEthereumContract();
    const tapp = await transactionsContract.methods.getTotalCreatedNodesByTier(0).call();
    const tbld = await transactionsContract.methods.getTotalCreatedNodesByTier(1).call();
    const thse = await transactionsContract.methods.getTotalCreatedNodesByTier(2).call();

    settotalAppartment(tapp);
    settotalBuilding(tbld);
    settotalHouse(thse);

  };
  const getMyTotalNode = async () => {
    const accounts = await ethereum.request({ method: "eth_requestAccounts" });
    const account = accounts[0];

    //getAllNodes
    //const getAllNodes = await transactionsContract.methods.getAllNodes(account).call();

    //   await transactionsContract.methods.getAllNodes(account).call().then((getAllNodes) => {
    //     console.log('totalNodes', getAllNodes)
    //  });

    //getNodeReward
    //getAllNodesRewards
    const nodeManagerContract = await getNodeManager();
    await nodeManagerContract.methods
      .getAllNodes(account)
      .call()
      .then((tNodes) => {
        console.log("tNodes", tNodes);
      });

    getTotalRewardAmount(account);

    promise.push(await getNodesNames(account));
    promise.push(await getNodesCreatime(account));
    promise.push(await getNodesRewards(account));
    promise.push(await nodeManagerContract.methods.getAllNodes(account).call());
    console.log(promise);
    //var currFee = 0
    await Promise.all(promise).then((result) => {
      for (var index in result[0]) {
        var mName = "";

        switch (result[3][index].tier) {
          case "0":
            mName = "Appartment";
            break;
          case "1":
            mName = "Building";
            break;
          case "2":
            mName = "House";
            break;
          case "3":
            mName = "Villa";
            break;
        }

        nodes.push({
          id: nodes.length + 1,
          nodeName: result[0][index],
          createTime: result[1][index],
          reward: Number(web3.utils.fromWei(result[2][index])).toFixed(9),
          rewardAmount: result[2][index],
          mName: mName,
          tier: result[3][index].tier,
        });

        console.log(nodes);
      }

      setallModule((allModule) => [...allModule, nodes]);
    });
  };

  const getNodesNames = async (account) => {
    const transactionsContract = await getEthereumContract();
    const allNodes = await transactionsContract.methods.getNodesNames().call({
      from: account,
    });
    setmyTotalNodes(allNodes.split(separator).length);
    return allNodes.split(separator);
  };

  const getNodesCreatime = async (account) => {
    const transactionsContract = await getEthereumContract();
    const nodesCreateTime = await transactionsContract.methods
      .getNodesCreatime()
      .call({
        from: account,
      });
    return nodesCreateTime.split(separator);
  };

  const getNodesRewards = async (account) => {
    const transactionsContract = await getEthereumContract();
    const nodesRewards = await transactionsContract.methods
      .getNodesRewards()
      .call({
        from: account,
      });
    return nodesRewards.split(separator);
  };
  const cashoutReward = async (createTime) => {
    const transactionsContract = await getEthereumContract();
    const transactionHash = await transactionsContract.methods
      .cashoutReward(createTime)
      .send({
        from: currentAccount,
        gas: 2100000,
      });

    setIsLoading(true);
    console.log(`Loading - ${transactionHash.hash}`);
    //await transactionHash.wait();
    console.log(`Success - ${transactionHash.hash}`);
    setIsLoading(false);

    window.location.reload(false);
  };

  const upgradeNode = async (createTime) => {
    const transactionsContract = await getEthereumContract();
    const transactionHash = await transactionsContract.methods
      .upgradeNode(createTime)
      .send({
        from: currentAccount,
        gas: 2100000,
      });

    setIsLoading(true);
    console.log(`Loading - ${transactionHash.hash}`);
    //await transactionHash.wait();
    console.log(`Success - ${transactionHash.hash}`);
    setIsLoading(false);

    window.location.reload(false);
  };
  const createNode = async (formData) => {
    try {
      //checkIfWalletIsConnected();

      const { moduleName, totalMSTATE, iAgree, tierId } = formData;
      console.log("totalMSTATE: " + totalMSTATE);

      const transactionsContract = await getEthereumContract();
      // const provider = Web3.providers.HttpProvider(TEST_NET_URL);
      //   //const provider = new Web3.providers.WebsocketProvider('wss://ropsten.infura.io/v3/1234543');
      //   const web3 = new Web3(Web3.givenProvider || provider);
      // const contract = new web3.eth.Contract(CONTRACT_ABI, CONTRACT_ADDRESS);

      const walletBalance = await getBalance();
      console.log(`total balance: ${walletBalance} for ${currentAccount}`);
      console.log(`module name: ${moduleName} tire selected ${tierId}`);

      // alert(CONTRACT_ADDRESS);
      // await transactionsContract.methods.approve(CONTRACT_ADDRESS, 10).send({ from: currentAccount, gas: 210000 })
      // .then((ret) => {
      //    transactionsContract.methods.createNodeWithTokens(moduleName, tierId).send({ from: currentAccount, gas: 210000 })
      //         .then((res) => {
      //         console.log(res);
      //             //store.dispatch({ type: "GET_USER_INFO", payload: { can_perform: true } });
      //         }).catch(() => {
      //           console.log(ret);
      //             //store.dispatch({ type: "UPDATE_CAN_PERFORM_STATUS", payload: { can_perform: true } });
      //         });
      // }).catch((ret) => {
      //     //store.dispatch({ type: "UPDATE_CAN_PERFORM_STATUS", payload: { can_perform: true } });
      //     console.log(ret);
      // });

      const transactionHash = await transactionsContract.methods
        .createNodeWithTokens(moduleName, tierId)
        .send({
          from: currentAccount,
          gas: 2100000,
        });

      const totalNodes = await transactionsContract.methods
        .getTotalCreatedNodes()
        .call();

      //getAllNodes

      settotalNodes(totalNodes);

      //const transactionHash = await transactionsContract.createNodeWithTokens('Kamran Haq');

      setIsLoading(true);
      console.log(`Loading - ${transactionHash.hash}`);
      //await transactionHash.wait();
      console.log(`Success - ${transactionHash.hash}`);
      setIsLoading(false);
      console.log(totalNodes);
      window.location.reload(false);

      //console.log(gNN);
      //alert('create node');
    } catch (error) {
      console.log(error);

      toast.error(JSON.stringify(error.message), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const checkIfWalletIsConnected = async () => {
    try {
      if (!ethereum)
        return toast.info(
          "MetaMask is not installed. Please consider installing it: https://metamask.io/download.html",
          {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );

      // check if the chain to connect to is installed
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x61" }], // chainId must be in hexadecimal numbers
      });

      const accounts = await ethereum.request({
        method: "eth_accounts",
      });

      if (accounts.length) {
        setCurrentAccount(accounts[0]);
        // getTotalRewardAmount(accounts[0]);

        // promise.push(getNodesNames(accounts[0]));
        // promise.push(getNodesCreatime(accounts[0]));
        // promise.push(getNodesRewards(accounts[0]));
        // console.log(promise);
        // Promise.all(promise).then((result) => {
        //   for (var index in result[0]) {
        //     nodes.push({
        //       id: nodes.length + 1,
        //       nodeName: result[0][index],
        //       createTime: result[1][index],
        //       reward: result[2][index], //Number(web3.utils.fromWei(result[2][index])).toFixed(9)
        //     });

        //     console.log(nodes);
        //   }

        //   setallModule((allModule) => [...allModule, nodes]);
        // });
      } else {
        toast.info("User is not logged in to MetaMask.", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      console.log(accounts);
      //setCurrentAccount(accounts[0]);
    } catch (error) {
      // This error code indicates that the chain has not been added to MetaMask
      // if it is not, then install it into the user MetaMask
      if (error.code === 4902) {
        try {
          await ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                name: "Binance",
                chainId: "0x61",
                rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545/",
              },
            ],
          });
        } catch (error) {
          console.error(error);
          toast.error(JSON.stringify(error.message), {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });     
        }
      }
      console.error(error);

      toast.error(JSON.stringify(error.message), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });     

    }
  };

  const connectWallet = async () => {
    try {
      if (!ethereum)
        return toast.info(
          "MetaMask is not installed. Please consider installing it: https://metamask.io/download.html",
          {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );

      await ethereum.enable();

      // check if the chain to connect to is installed
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x61" }], // chainId must be in hexadecimal numbers
      });

      const accounts = await ethereum
        .request({
          method: "eth_requestAccounts",
        })
        .then((accounts) => {
          console.log(`Selected account is: ${accounts[0]}`);
        })
        .catch((err) => {
          console.log(err);
          toast.error(JSON.stringify(err.message), {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });     
        });

      if (accounts.length) {
        setCurrentAccount(accounts[0]);
      } else {
        toast.info("User is not logged in to MetaMask.", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      //setCurrentAccount(accounts[0]);
    } catch (error) {
      // This error code indicates that the chain has not been added to MetaMask
      // if it is not, then install it into the user MetaMask
      if (error.code === 4902) {
        try {
          await ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                name: "Binance",
                chainId: "0x61",
                rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545/",
              },
            ],
          });
        } catch (error) {
          console.error(error);
          toast.error(JSON.stringify(error.message), {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });     
    
        }
      }
      console.error(error);
      toast.error(JSON.stringify(error.message), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });     
      // console.log(error);
      // throw new Error("No ethereum object.");
    }
  };

  useEffect(() => {
    ethereum.on("accountsChanged", function (accounts) {
      setCurrentAccount(accounts[0]);
      console.log(`Selected account changed to:  ${accounts[0]}`);
      window.location.reload(false);
    });

    checkIfWalletIsConnected();

    getTotalAllNode();

    getMyTotalNode();

    getTotalNodesByTire();

    //console.log(totalNodes);
    //checkNetwork();
  }, []);

  return (
    <RewardManagementContext.Provider
      value={{
        connectWallet,
        currentAccount,
        totalNodes,
        totalHouse,
        totalBuilding,
        totalAppartment,
        myTotalNodes,
        myTotalRewards,
        myTotalFees,
        rewardsPerNode,
        allModule,
        createNode,
        cashoutReward,
        upgradeNode,
        getNodesNames,
        getNodeFee,
      }}
    >
      {children}
    </RewardManagementContext.Provider>
  );
};
